<template>
	<div>
		<!-- 面包屑导航区域 -->
		<el-breadcrumb separator="/">
			<el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
			<el-breadcrumb-item><span>权限管理</span></el-breadcrumb-item>
			<el-breadcrumb-item>按钮权限管理</el-breadcrumb-item>
		</el-breadcrumb>

		<!-- 卡片视图区域 -->
		<el-card class="box-card">
			<!-- 搜索与添加区域 -->
			<div class="search-area">
				<el-form ref="searchForm" :model="searchForm" label-width="70px" inline size="small">
					<el-form-item label="按钮名称:">
						<el-input :clearable="true" v-model="searchForm.buttonName" placeholder="请输入按钮名称" style="width: 150px;" />
					</el-form-item>
					<el-form-item label="按钮编码:">
						<el-input :clearable="true" v-model="searchForm.buttonCode" placeholder="请输入按钮编码" style="width: 150px;" />
					</el-form-item>
					<el-form-item label="所属菜单:">
						<el-select v-model="searchForm.menuId" placeholder="请选择菜单" style="width: 150px;" clearable>
							<el-option label="全部菜单" value=""></el-option>
							<el-option v-for="item in getAllMenuOptions()" :key="item.value" :label="item.label" :value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button style="background-color: #3CA757;color: #FFFFFF;" @click="getButtonList()">查询</el-button>
					</el-form-item>
					<el-form-item>
						<el-button style="background-color: #3CA757;color: #FFFFFF;" @click="addButtonInit()">+ 添加按钮</el-button>
					</el-form-item>
				</el-form>
			</div>

			<!-- 按钮列表区 -->
			<el-table :data="buttonList" style="width: 100%;margin-top: 20px;" :header-cell-style="{textAlign: 'center'}" :cell-style="{textAlign: 'center'}"
			 border :stripe="true" :highlight-current-row="true">
				<el-table-column type="index" width="60"></el-table-column>
				<el-table-column prop="buttonName" label="按钮名称" sortable>
				</el-table-column>
				<el-table-column prop="buttonCode" label="按钮编码" sortable>
				</el-table-column>
				<el-table-column prop="menuId" label="菜单ID">
					<template slot-scope="scope">
						{{ getMenuName(scope.row.menuId) }}
					</template>
				</el-table-column>
				<el-table-column prop="pagePath" label="页面路径">
				</el-table-column>
				<el-table-column prop="icon" label="按钮图标">
				</el-table-column>
				<el-table-column prop="orderNum" label="排序号" sortable>
				</el-table-column>
				<el-table-column fixed="right" header-align="center" align="center" width="150" label="操作">
					<template slot-scope="scope">
						<el-button size="mini" style="background-color: #3CA757;color: #FFFFFF;" icon="el-icon-edit" @click="updateButtonInit(scope.row)">编辑</el-button>
						<el-button size="mini" type="danger" icon="el-icon-delete" @click="deleteButton(scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>

			<!-- 分页区域 -->
			<el-pagination
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page="currentPage"
				:page-sizes="[10, 20, 50, 100]"
				:page-size="pageSize"
				layout="total, sizes, prev, pager, next, jumper"
				:total="total"
				style="margin-top: 20px; text-align: right;"
			></el-pagination>

			<!-- 添加按钮 -->
			<el-dialog title="添加按钮" :visible.sync="addButtonDialogVisible" width="800px">
				<!-- form表单 -->
				<el-form :model="buttonForm" style="margin-right: 1.50rem;" status-icon :rules="buttonRules" ref="buttonForm"
				 label-width="100px" class="demo-ruleForm">
					<el-form-item label="所属菜单" prop="menuId">
						<el-select style="width: 100%;" v-model="buttonForm.menuId" :filterable=true size="small"
					 placeholder="请选择所属菜单">
					<el-option v-for="item in getAllMenuOptions()" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
					</el-form-item>
					<el-form-item label="按钮名称" prop="buttonName">
						<el-input placeholder="请输入按钮名称" v-model="buttonForm.buttonName" size="small" :clearable=true></el-input>
					</el-form-item>
					<el-form-item label="按钮编码" prop="buttonCode">
						<el-input placeholder="请输入按钮编码" v-model="buttonForm.buttonCode" size="small" :clearable=true @blur="checkButtonCode"></el-input>
						<el-alert v-if="codeError" :title="codeError" type="error" show-icon :closable=false style="margin-top: 10px;"></el-alert>
					</el-form-item>
					<el-form-item label="页面路径" prop="pagePath">
						<el-input placeholder="请输入页面路径" v-model="buttonForm.pagePath" size="small" :clearable=true></el-input>
					</el-form-item>
					<el-form-item label="按钮图标" prop="icon">
						<el-input placeholder="请输入按钮图标" v-model="buttonForm.icon" size="small" :clearable=true></el-input>
					</el-form-item>
					<el-form-item label="排序号" prop="orderNum">
						<el-input placeholder="请输入排序号" v-model.number="buttonForm.orderNum" size="small" :clearable=true type="number"></el-input>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button @click="addButtonDialogVisible = false">取 消</el-button>
					<el-button style="background-color: #3CA757;color: #FFFFFF;" @click="addButton">确 定</el-button>
				</span>
			</el-dialog>

			<!-- 按钮修改 -->
			<el-dialog title="修改按钮" :visible.sync="updateButtonDialogVisible" width="800px">
				<!-- form表单 -->
				<el-form :model="buttonForm" style="margin-right: 1.50rem;" status-icon :rules="buttonRules" ref="buttonForm"
				 label-width="100px" class="demo-ruleForm">
					<el-form-item label="所属菜单" prop="menuId">
						<el-select style="width: 100%;" v-model="buttonForm.menuId" :filterable=true size="small"
					 placeholder="请选择所属菜单">
					<el-option v-for="item in getAllMenuOptions()" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
					</el-form-item>
					<el-form-item label="按钮名称" prop="buttonName">
						<el-input placeholder="请输入按钮名称" v-model="buttonForm.buttonName" size="small" :clearable=true></el-input>
					</el-form-item>
					<el-form-item label="按钮编码" prop="buttonCode">
						<el-input placeholder="请输入按钮编码" v-model="buttonForm.buttonCode" size="small" :clearable=true @blur="checkButtonCode"></el-input>
						<el-alert v-if="codeError" :title="codeError" type="error" show-icon :closable=false style="margin-top: 10px;"></el-alert>
					</el-form-item>
					<el-form-item label="页面路径" prop="pagePath">
						<el-input placeholder="请输入页面路径" v-model="buttonForm.pagePath" size="small" :clearable=true></el-input>
					</el-form-item>
					<el-form-item label="按钮图标" prop="icon">
						<el-input placeholder="请输入按钮图标" v-model="buttonForm.icon" size="small" :clearable=true></el-input>
					</el-form-item>
					<el-form-item label="排序号" prop="orderNum">
						<el-input placeholder="请输入排序号" v-model.number="buttonForm.orderNum" size="small" :clearable=true type="number"></el-input>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button @click="updateButtonDialogVisible = false">取 消</el-button>
					<el-button style="background-color: #3CA757;color: #FFFFFF;" @click="updateButton">确 定</el-button>
				</span>
			</el-dialog>
		</el-card>
	</div>
</template>

<script>
export default {
	data() {
		return {
			currentPage: 1,
			pageSize: 10,
			total: 0,
			searchForm: {
				buttonName: '',
				buttonCode: '',
				menuId: ''
			},
			buttonForm: {
				orderNum: 0
			},
			menuTree: [],
			buttonList: [],
			codeError: '',
			//控制添加用户信息对话框显示与隐藏
			addButtonDialogVisible: false,
			updateButtonDialogVisible: false,
			buttonRules: {
				//验证是否合法
				buttonName: [{
					required: true,
					message: '请输按钮名称',
					trigger: 'blur',
				},
				{
					min: 2,
					max: 100,
					message: '长度在 2 到 100 个字符',
					trigger: 'blur',
				}
				],
				buttonCode: [{
					required: true,
					message: '请输按钮编码',
					trigger: 'blur',
				},
				{
					min: 2,
					max: 100,
					message: '长度在 2 到 100 个字符',
					trigger: 'blur',
				}
				],
				menuId: [{
					required: true,
					message: '请选择所属菜单',
					trigger: 'blur',
				}
				],
				pagePath: [{
					required: true,
					message: '请输页面路径',
					trigger: 'blur',
				}
				],
				orderNum: [{
					required: true,
					message: '请输排序号',
					trigger: 'blur',
				},
				{
					type: 'number',
					message: '请输入数值类型',
					trigger: 'blur',
					transform: (value) => Number(value)
				}
				]
			}
		}
	},
	created() {
		this.getButtonList()
		this.getMenuTree()
	},
	methods: {
		handleSizeChange(val) {
			this.pageSize = val
			this.getButtonList()
		},
		handleCurrentChange(val) {
			this.currentPage = val
			this.getButtonList()
		},
		async getButtonList() {
			const { data: res } = await this.$http.get('/api/permission/button/page', {
				params: {
					current: this.currentPage,
					size: this.pageSize,
					buttonName: this.searchForm.buttonName,
					buttonCode: this.searchForm.buttonCode,
					menuId: this.searchForm.menuId
				}
			})
			if (res.code != 200) return this.$message.error(res.message)
			this.buttonList = res.data.records
			this.total = res.data.total
		},
		async getMenuTree() {
			const { data: res } = await this.$http.get('/api/permission/menu/tree')
			if (res.code != 200) return this.$message.error(res.message)
			this.menuTree = res.data
		},
		// 递归获取所有菜单选项，包括二级菜单
		getAllMenuOptions() {
			const options = [];
			const processMenu = (menuTree, prefix = '') => {
				menuTree.forEach(menu => {
					options.push({
						label: prefix + menu.menuName,
						value: menu.id
					});
					if (menu.children && menu.children.length > 0) {
						processMenu(menu.children, prefix + '└ ');
					}
				});
			};
			processMenu(this.menuTree);
			return options;
		},
		// 根据menuId获取菜单名称，包括二级菜单
		getMenuName(menuId) {
			if (!menuId) return '';
			// 递归查找菜单
			const findMenu = (menuTree, id) => {
				for (const menu of menuTree) {
					if (menu.id == id) {
						return menu.menuName;
					}
					if (menu.children && menu.children.length > 0) {
						const result = findMenu(menu.children, id);
						if (result) {
							return result;
						}
					}
				}
				return '';
			};
			return findMenu(this.menuTree, menuId);
		},
		addButtonInit() {
			this.addButtonDialogVisible = true
			this.buttonForm = {
				orderNum: 0
			}
			this.codeError = ''
		},
		async addButton() {
			this.$refs.buttonForm.validate(async (valid) => {
				if (valid) {
					// 确保orderNum是数字类型
					const formData = { ...this.buttonForm }
					formData.orderNum = Number(formData.orderNum)
					const { data: res } = await this.$http.post('/api/permission/button/saveOperateButtonPermission', formData)
					if (res.code == 200) {
						this.addButtonDialogVisible = false
						this.getButtonList()
						this.$message.success('添加成功')
					} else {
						this.$message.error(res.message)
					}
				}
			})
		},
		async checkButtonCode() {
			if (!this.buttonForm.buttonCode) {
				this.codeError = ''
				return
			}
			const { data: res } = await this.$http.get('/api/permission/button/check-code', {
				params: {
					buttonCode: this.buttonForm.buttonCode,
					id: this.buttonForm.id
				}
			})
			if (res.code == 200) {
				if (res.data.exist) {
					this.codeError = '按钮编码已存在'
				} else {
					this.codeError = ''
				}
			}
		},
		deleteButton(row) {
			this.$confirm("确认删除该按钮吗？", {
				title: "提示",
				type: 'warning',
			}).then(async () => {
				const { data: res } = await this.$http.delete(`/api/permission/button/${row.id}`)
				if (res.code == 200) {
					this.getButtonList()
					this.$message.success('删除成功')
				} else {
					this.$message.error(res.message)
				}
			})
		},
		updateButtonInit(row) {
			this.buttonForm = { ...row }
			// 确保orderNum是数字类型
			this.buttonForm.orderNum = Number(this.buttonForm.orderNum)
			this.updateButtonDialogVisible = true
			this.codeError = ''
		},
		async updateButton() {
			this.$refs.buttonForm.validate(async (valid) => {
				if (valid) {
					// 确保orderNum是数字类型
					const formData = { ...this.buttonForm }
					formData.orderNum = Number(formData.orderNum)
					const { data: res } = await this.$http.put('/api/permission/button', formData)
					if (res.code == 200) {
						this.getButtonList()
						this.updateButtonDialogVisible = false
						this.$message.success('修改成功')
					} else {
						this.$message.error(res.message)
					}
				}
			})
		}
	}
}
</script>

<style>
	.search-area {
		margin-bottom: 20px;
	}

	.el-radio__input.is-checked+.el-radio__label {
		color: #3CA757 !important;
	}

	.el-radio__input.is-checked .el-radio__inner {
		border-color: #3CA757 !important;
		background: #3CA757 !important;
	}
</style>